import { useEffect } from 'react'
import useAuth from '../hooks/useAuth'
import { useNavigate } from 'react-router-dom'

const ONE_MINUTE = 60 * 1000

export function UpdateCheck() {
  const { signOut } = useAuth()

  const navigate = useNavigate()

  const handleSignOut = async () => {
    localStorage.removeItem('closedAnnouncements')
    await signOut()
    navigate('/auth/sign-in')
  }

  /**
   * Check for updates to the frontend application.
   * Reloads the application if a new version is detected.
   * @see vite.config.ts for the version.json generation.
   */
  const checkForUpdate = async () => {
    try {
      const response = await fetch('/version.json', { cache: 'no-store' })
      const { version: latestVersion } = await response.json()
      const currentVersion = localStorage.getItem('spineFrontendVersion')

      if (latestVersion !== null && latestVersion !== currentVersion) {
        console.log('New version detected:', latestVersion)
        localStorage.setItem('spineFrontendVersion', latestVersion)
        window.location.reload()

        await handleSignOut()
      }
    } catch (_error) {
      /* empty */
    }
  }

  useEffect(() => {
    const interval = setInterval(checkForUpdate, ONE_MINUTE)
    checkForUpdate()
    return () => clearInterval(interval)
  })

  return <></>
}
